import { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import { useSelector } from "react-redux";
import { formatDinero } from "./../../../utils/formatDinero";

const columns = [
  { id: "cliente", minWidth: 150, align: "center", label: "Cliente" },
  { id: "calveRastreo", minWidth: 150, align: "center", label: "Clave de rastreo" },
  { id: "referencia", minWidth: 150, align: "center", label: "Referencia" },
  { id: "monto", minWidth: 150, align: "center", label: "Monto" },
  { id: "fecha", minWidth: 150, align: "center", label: "Fecha" },
  { id: "action", minWidth: 50, align: "center", label: "" },
];

const useStyles = makeStyles({
  root: {
    width: "100%",
    marginTop: "15px",
  },
  container: {
    maxHeight: 440,
  },
});

export default function TPagos() {
  const rows = useSelector(store => store.pagosMasivos.array);
  console.log("🚀 ~ file: TPagos.jsx ~ line 35 ~ TPagos ~ rows", rows)
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.id_Deposito_Banco}>
                    <TableCell align="center">
                      {`${row.Cuenta.Nombre} ${row.Cuenta.Apellido_Paterno} ${row.Cuenta.Apellido_Materno}`}
                    </TableCell>
                    <TableCell align="center">{row.claveRastreo}</TableCell>
                    <TableCell align="center">
                      {row.referencia}
                    </TableCell>
                    <TableCell align="center">{`${formatDinero(row.monto)}`}</TableCell>
                    <TableCell align="center">
                      {`${row.fecha.split(" ")[0].split("/")[1]}-${row.fecha.split(" ")[0].split("/")[0]}-${row.fecha.split(" ")[0].split("/")[2]}`}
                    </TableCell>
                    <TableCell>

                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
